import * as React from 'react';
import { Flex } from '../../../../../components/common/flex';
import { IServiceCardProps } from './service_card.d';

export const ServiceCard: React.FC<IServiceCardProps> = ({ service }) => {
  return (
    <Flex vertical className={'item-card'}>
      <div className={'item-card__header'}>
        <div className={'item-card__title'}>{service.service_name}</div>
      </div>

      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Период предоставления услуги</div>
        <div className={'item-row__text'}>{service.dates_period}</div>
      </Flex>
      <Flex vertical align={'start'} className={'item-row'}>
        <div className={'item-row__title'}>Стоимость</div>
        <Flex vertical gap={2}>
          <div className={'item-row__text'}>{service.price}</div>
          <div className={'item-row__text'}>Включена в общую стоимость</div>
        </Flex>
      </Flex>
    </Flex>
  );
};
